import { ProductConfig } from '@chegg/wt-checkout'

export const DEFAULT_PRICE = '$9.95'
export const DEFAULT_FREE_TRIAL = true
export const DEFAULT_PRICING_EXPERIMENT = 'BASE'
export const BASE_PRICE = 9.95

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getProductConfig = (hasFreeTrial?: boolean): ProductConfig => {
  return {
    itemId: 'CHGMnthBMPlusFT',
    productCode: 'BIBME',
    basePrice: BASE_PRICE,
  }
}
